import React from 'react';
import { useNavigation } from '@react-navigation/native';
import { ModuleScreenView } from './ModuleScreenView';
import ModuleScreenOld from './ModuleScreenOld';
import { useLeaveTerminalModule } from './hooks/useLeaveTerminalModule';
import { useModuleScreen } from './hooks/useModuleScreen';
import { useUserFeatures } from '../../common/hooks/useUserFeatures';

/**
 * ModuleScreen container.
 * Orchestrates logic and presentation for the module view.
 *
 * It respects the 'student-new-ui' feature flag to support A/B testing or
 * gradual rollout of the new architecture.
 */
export const ModuleScreen: React.FC = () => {
  // TODO: Define proper navigation type for student stack
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigation = useNavigation<any>();
  const { isFeatureActive } = useUserFeatures();
  const isNewUiActive = isFeatureActive('student-new-ui');

  const logic = useModuleScreen();
  const leaveTerminalModule = useLeaveTerminalModule({
    module: logic.module,
    isLoading: logic.isModulesLoading,
    courseId: logic.selectedModule?.courseId || logic.module?.courses?.[0]?.id,
    navigation,
  });

  if (leaveTerminalModule) {
    return null;
  }

  if (!isNewUiActive) {
    return <ModuleScreenOld />;
  }

  return <ModuleScreenView {...logic} />;
};

export default ModuleScreen;
